import { render } from "./InvoiceCreate.vue?vue&type=template&id=eb0804dc"
import script from "./InvoiceCreate.vue?vue&type=script&lang=js"
export * from "./InvoiceCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__